import 'style/not-found.scss';

$(document).ready(() => {

});



// WEBPACK FOOTER //
// ./static/js/notFound.js